import { render, staticRenderFns } from "./UpgradeDetail.vue?vue&type=template&id=ea224d8c&scoped=true"
import script from "./UpgradeDetail.vue?vue&type=script&lang=js"
export * from "./UpgradeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea224d8c",
  null
  
)

export default component.exports